import { render, staticRenderFns } from "./OrderStatusBanner.vue?vue&type=template&id=0d86009e&scoped=true&"
import script from "./OrderStatusBanner.vue?vue&type=script&lang=js&"
export * from "./OrderStatusBanner.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusBanner.vue?vue&type=style&index=0&id=0d86009e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d86009e",
  null
  
)

export default component.exports